import { render, staticRenderFns } from "./SvgStopHand.vue?vue&type=template&id=76f53f3a&"
import script from "./SvgStopHand.vue?vue&type=script&lang=js&"
export * from "./SvgStopHand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports